import type { Notification } from "./schemas";

/**
 * Where opening a notification takes someone.
 *
 * An announcement opens on itself. It is a message from the organisers, often
 * carrying a link (a survey, a room change), and the event page shows neither
 * the message nor the link. The event page also only resolves for a published
 * event, so an announcement sent to the roster of a draft event led to "Event
 * not found". Event-start and agenda-change notifications are about the event
 * itself and keep opening it.
 *
 * The backend builds the same path for the push click in
 * `notification.notification_path`; keep the two in step.
 */
export function opensOnItself(
  notification: Pick<Notification, "type">,
): boolean {
  return notification.type === "ANNOUNCEMENT";
}

/**
 * A new connection (TNG-93) opens the connections list, where the person now
 * is, rather than the event it happened at.
 */
export function opensConnections(
  notification: Pick<Notification, "type">,
): boolean {
  return notification.type === "CONNECTION";
}
